import * as types from "./type";

const initialState = {
  open: false,
  message: "",
  type: "info", // can be: "success", "error", "warning", "info"
};

const toastReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.SHOW_TOAST:
      return {
        ...state,
        open: true,
        message: action.payload.message,
        type: action.payload.type || "info",
      };
    case types.HIDE_TOAST:
      return {
        ...state,
        open: false,
        message: "",
        type: "info",
      };
    default:
      return state;
  }
};

export default toastReducer;